<template>
    <template v-if="visible">
        <div>
            <el-form-item>
                <div slot="label" class="input-form-setting">
                    {{ title }}
                    <button class="transparent" type="button" @click="showDialog=true"><span class="normal-command-text" v-t="'message.title_selection_do'"></span></button>
                </div>
                <el-input type="text" v-model="parameter.value" :disabled="disabled" :placeholder="$t('message.place_holder_select_item')"/>
            </el-form-item>

            <Dialog v-if="showDialog" :size="'small'">
                <template v-slot:title>
                    {{ $t('message.title_select_user') }}
                </template>

                <template v-slot:body>
                    <DialogTree
                        v-bind:initialData="[rootNode]"
                        @on-selectnode="handleOnSelectNode"
                        selectionType=1
                    />
                </template>

                <template v-slot:button>
                    <el-button class="dialog-cancel-button" type="button" @click="cancel" v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" :disabled="disableSave" @click="save" v-t="'message.action_selection'"></el-button>
                </template>
            </Dialog>
        </div>
    </template>
</template>

<script>
import commonUtil from '@/components/commonutil.js';
import processorTemplateUtil from './AiAppSettingUtil.js';
import Dialog from "@/components/pc/common/Dialog";
import DialogTree from "@/components/DialogTree";

export default {
    components: { Dialog, DialogTree },

    props: {
        parameter: {
            type: Object,
            required: true,
        },
        dependParameter: {
            type: String,
            default: null
        }
    },

    data() {
        return {
            rootNode: {
                tenantId: this.$root.store.tenantId,
                id: 1,
                label: "ROOT-NODE",
                type: 0,
                isLeaf: false
            },
            dependValue: null,
            selectedUser: null,
            disableSave: true,
            showDialog: false
        };
    },

    computed: {
        title() {
            return processorTemplateUtil.getLocaledText(this.$i18n, this.parameter.title);
        },
        noDataTextOfSelection() {
            if (this.$i18n.locale === 'ja') {
                return commonUtil.getMessageText(this.$i18n, "info_no_selection_data").replace("{selectionItemName}", this.parameter.title.ja);
            } else {
                return commonUtil.getMessageText(this.$i18n, "info_no_selection_data").replace("{selectionItemName}", this.parameter.title.en);
            }
        },
        visible() {
            return processorTemplateUtil.judgeVisible(this.parameter);
        },
        disabled() {
            return processorTemplateUtil.judgeDisabled(this.parameter);
        }
    },

    mounted() {
        if (this.parameter.value != null) {
            this.$emit('update:valid', true)
            this.$emit('update', this.parameter.jsonKey, this.parameter.value)
        }
    },

    methods: {
        handleOnSelectNode(data) {
            if (data.isLeaf && data.type === 1) {
                this.selectedUser = data
                this.disableSave = false
            }
        },
        save() {
            this.parameter.value = this.selectedUser.name
            this.disableSave = true
            this.showDialog = false
            this.$emit('update:valid', true)
            this.$emit('update', this.parameter.jsonKey, this.parameter.value)
        },
        cancel() {
            this.disableSave = true
            this.showDialog = false
        },
        getDependParameter() {
            return this.dependParameter
        },
        onChangeDependParameter(value) {
            this.dependValue = value
            this.parameter.value = ''
        }
    }
}

</script>

<style scoped>

.input-form-setting {
    padding-left: 15px;
    text-align: left;
}

.el-form-item {
    margin-right: 100px
}

</style>
